<template lang="jade">
  div.Form__columns
    div.Form__column(v-for="column in columns")
      component(
        v-for="field in column"
        ":is"= "field.type"
        ":fdata"="field"
      )
</template>

<script>
import _ from 'lodash'

export default {
  data () {
    return {}
  },
  computed: {
    columns () {
      return this.fdata.partition
        ? _.chunk(this.fdata.content, this.fdata.content.length / this.fdata.columns)
        : this.fdata.content
    }
  },
  props: {
    fdata: {
      type: Object,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// columns.vue?42c99d8e